var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "get-started" }, [
    _c("div", { staticClass: "container" }, [
      _c("h3", [_vm._v("How to get started")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "btn-container" }, [
        _c(
          "a",
          {
            directives: [
              {
                name: "track",
                rawName: "v-track:click",
                value: {
                  axId: "clicked_schools_apply_footer",
                  axType: "button"
                },
                expression:
                  "{\n          axId: 'clicked_schools_apply_footer',\n          axType: 'button',\n        }",
                arg: "click"
              }
            ],
            staticClass: "btn blue",
            attrs: {
              href: _vm.$router.resolve({ name: "teacher_application" }).href
            }
          },
          [_vm._v("\n        Apply for access\n      ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "items" }, [
      _c("div", { staticClass: "item" }, [
        _c("span", { staticClass: "yellow-dot" }, [_vm._v("1")]),
        _vm._v(" "),
        _c("h4", [_vm._v("Apply to the program")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n          Apply for an Education account by filling out our signup form. We’ll also ask you to\n          complete a survey to assess your needs.\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("span", { staticClass: "yellow-dot" }, [_vm._v("2")]),
        _vm._v(" "),
        _c("h4", [_vm._v("Create classes and assign content")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n          Once verified and accepted, educators can choose up to 6 courses and unlimited Daily\n          Challenges that each of their classes will have access to.\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("span", { staticClass: "yellow-dot" }, [_vm._v("3")]),
        _vm._v(" "),
        _c("h4", [_vm._v("Invite your students")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n          Invite your students and get started! Feel free to email\n          "
          ),
          _c("a", { attrs: { href: "mailto:educators@brilliant.org" } }, [
            _vm._v("educators@brilliant.org")
          ]),
          _vm._v("\n          with any questions or feedback.\n        ")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }